<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col-md-6">
        <h6 class="mb-0 me-auto">Lista de usuarios</h6>
        </div>
        <div class="col-md-6 d-flex justify-content-md-end justify-content-start mt-2 mt-md-0">
        <router-link
          :to="{ name: 'User Create' }"
          class="btn btn-sm btn-primary text-white"
          title="Agregar usuario"
        >
          <i class="fa fa-plus me-1"></i> Agregar
        </router-link>
      </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >N° documento</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cargo</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Estado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Ultima conexión</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="user in users" :key="user.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <!-- <div>
                    <img
                      src="../../../assets/img/team-2.jpg"
                      class="avatar avatar-sm me-3"
                      alt="user1"
                    />
                  </div> -->
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ user.name }}</h6>
                    <p class="text-xs text-secondary mb-0">{{ user.email }}</p>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ formatDocumentDisplay(user) }}
                </span>
              </td>
              <td class="align-middle text-center text-sm">
                {{ 
                  user.role === '1' ? 'Administrador' : 
                  user.role === '2' ? 'Supervisor' : 
                  user.role === '3' ? 'Operario' : 
                  user.role === '4' ? 'Cliente' : 
                  user.role === '5' ? 'Proveedor' : 
                  user.role === '6' ? 'Operador' : 
                  'Desconocido' 
                }}
              </td>
              
              <td class="align-middle text-center text-sm">
                <span 
                  class="badge badge-sm" 
                  :class="user.status === 1 ? 'bg-gradient-success' : 'bg-gradient-warning'"
                >
                  {{ user.status === 1 ? 'Activo' : 'Inactivo' }}
                </span>              
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ new Date(user.updated_at).toLocaleDateString('es-ES') }} 
                </span>
              </td>
              <td class="align-middle text-center">
                <router-link 
                  :to="{ name: 'User Create', params: { user: JSON.stringify(user) } , props: true }" 
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Agregar usuario"
                >
                <i class="fa fa-pencil-alt"></i>
                </router-link>
                <a
                  @click="deleteUser(user.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer " style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar usuario"
                >
                <i class="fa fa-trash"></i>
              </a>

              </td>
            </tr>
           
            <tr v-if="users.length === 0">
              <td colspan="6" class="text-center text-xxs">No hay registros disponibles</td>
            </tr>
          </tbody>
        </table>
    
      

        <div class="pagination p-3">
          <!-- Recorremos los links para generar los botones -->
          <a 
            v-for="link in links" 
            :key="link.label" 
            class="page-item cursor-pointer" 
            @click="fetchUsers(link.url)" 
            :disabled="!link.url || link.active" 
              :class="{ 'active': link.label === currentPage.toString() }"
          >
            {{ link.label }}
          </a>
        </div>

      </div>
    </div>

  </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'UserList',
  computed: {
    ...mapGetters('users', ['allUsers', 'currentPage', 'lastPage', 'links']), // Mapea el getter allUsers
    currentPage() {
        return this.$store.state.users.currentPage; // Obtiene la página actual
    },
    lastPage() {
        return this.$store.state.users.lastPage; // Obtiene la última página
    },
    users() {
        return this.allUsers; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['users/links']; // Retorna los links
    },
  },
  methods: {
    formatDocumentDisplay(user) {
      const doc = user?.document != null && String(user.document).trim() !== '' ? String(user.document).trim() : '';
      const type = user?.document_type != null && String(user.document_type).trim() !== '' ? String(user.document_type).trim() : '';
      if (!doc && !type) return '—';
      if (type && doc) return `${type} ${doc}`;
      return doc || type || '—';
    },
    async fetchUsers(pageUrl = null) {
      await this.$store.dispatch('users/fetchUsers',pageUrl); 
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("users/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchUsers();

            await Swal.fire(
              'Eliminado!',
              'El usuario ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el usuario:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el usuario',
        });
      }
    }

  },
  mounted() {
    this.fetchUsers(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}
</style>